import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromApp from '../../store/app.reducer';
import * as MeActions from '../../core/header/store/me.actions';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { MeData } from 'src/app/model/Me';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss'],
})
export class UserInfoComponent implements OnInit, OnDestroy {
  @Input() userName: string | undefined = ' ';
  @Input() userAvatarUrl: string = './assets/images/AvatarM.webp';
  @Input() size: 'small' | 'medium' | 'large' = 'small';
  @Input() fetchMe: boolean = true;
  @Input() fullName: string | undefined = ' ';

  meSubscription!: Subscription;
  public me!: MeData | null;
  isHM: boolean = false;

  constructor(private store: Store<fromApp.AppState>) {}

  ngOnInit(): void {
    if (this.fetchMe) {
      this.store.dispatch(MeActions.fetchMe());
      this.meSubscription = this.store
        .select('me')
        .pipe(map((meState) => meState.me))
        .subscribe((me: MeData | null) => {
          this.me = me;
          if (me) {
            this.fullName = `${me.firstName} ${me.lastName}`;
            this.userAvatarUrl = me.email;
            this.userName =
              me.firstName === me.lastName ? me.email : this.fullName;
          } else {
            this.userAvatarUrl = './assets/images/AvatarM.webp';
          }
          //   me != null
          //     ? ((this.userAvatarUrl = me.email),
          //       (this.userName = me.email),
          //       (this.fullName = `${me.firstName} ${me.lastName}`))
          //     : (this.userAvatarUrl = './assets/images/AvatarM.webp');
          //   console.log('me from user-info component:', this.me);

          // if (this.fullName?.includes('HM')) {
          //   this.isHM = true
          //   this.fullName = this.fullName.replace(/HM|HM_DOC/, '')
          // }

          if (this.fullName?.match(/\bHM\w*\b/)) {
            this.isHM = true;
            this.fullName = this.fullName.replace(/\bHM\w*\b/g, '');
          }
          
        });
    }
  }

  ngOnDestroy(): void {
    if (this.meSubscription) {
      this.meSubscription.unsubscribe();
    }
  }
}
